import { useQueryAllAnswersByFormInstanceKey } from 'queries/form-instance';

export const useGetAnswersFromFormInstance = ({ formInstanceId }) => {
  const { data: formInstanceAnswers } =
    useQueryAllAnswersByFormInstanceKey(formInstanceId);

  return formInstanceAnswers;
};
